import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_DOCUMENT_REQUEST = 'document/FETCH_DOCUMENT_REQUEST'
const FETCH_DOCUMENT_SUCCESS = 'document/FETCH_DOCUMENT_SUCCESS'
const FETCH_DOCUMENT_FAILURE = 'document/FETCH_DOCUMENT_FAILURE'

const FETCH_DOCUMENT_BY_HEROID_REQUEST = 'document/FETCH_DOCUMENT_BY_HEROID_REQUEST'
const FETCH_DOCUMENT_BY_HEROID_SUCCESS = 'document/FETCH_DOCUMENT_BY_HEROID_SUCCESS'
const FETCH_DOCUMENT_BY_HEROID_FAILURE = 'document/FETCH_DOCUMENT_BY_HEROID_FAILURE'

const FETCH_DOCUMENT_PENDING_REQUEST = 'document/FETCH_DOCUMENT_PENDING_REQUEST'
const FETCH_DOCUMENT_PENDING_SUCCESS = 'document/FETCH_DOCUMENT_PENDING_SUCCESS'
const FETCH_DOCUMENT_PENDING_FAILURE = 'document/FETCH_DOCUMENT_PENDING_FAILURE'

const CREATE_DOCUMENT_REQUEST = 'document/CREATE_DOCUMENT_REQUEST'
const CREATE_DOCUMENT_SUCCESS = 'document/CREATE_DOCUMENT_SUCCESS'
const CREATE_DOCUMENT_FAILURE = 'document/CREATE_DOCUMENT_FAILURE'

const UPDATE_DOCUMENT_REQUEST = 'document/UPDATE_DOCUMENT_REQUEST'
const UPDATE_DOCUMENT_SUCCESS = 'document/UPDATE_DOCUMENT_SUCCESS'
const UPDATE_DOCUMENT_FAILURE = 'document/UPDATE_DOCUMENT_FAILURE'

const DELETE_DOCUMENT_REQUEST = 'document/DELETE_DOCUMENT_REQUEST'
const DELETE_DOCUMENT_SUCCESS = 'document/DELETE_DOCUMENT_SUCCESS'
const DELETE_DOCUMENT_FAILURE = 'document/DELETE_DOCUMENT_FAILURE'

const UPDATE_DOCUMENT_BY_ADMIN_REQUEST = 'document/UPDATE_DOCUMENT_BY_ADMIN_REQUEST'
const UPDATE_DOCUMENT_BY_ADMIN_SUCCESS = 'document/UPDATE_DOCUMENT_BY_ADMIN_SUCCESS'
const UPDATE_DOCUMENT_BY_ADMIN_FAILURE = 'document/UPDATE_DOCUMENT_BY_ADMIN_FAILURE'


// Initialize State
const initialState = {
  isLoading: false,
  error: {},
  docList: [],
  heroDocument: [],
  heroDocumentPending: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DOCUMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_DOCUMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        docList: action.payload
      }
    case FETCH_DOCUMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case FETCH_DOCUMENT_BY_HEROID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_DOCUMENT_BY_HEROID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroDocument: action.payload
      }
    case FETCH_DOCUMENT_BY_HEROID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
      case FETCH_DOCUMENT_PENDING_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case FETCH_DOCUMENT_PENDING_SUCCESS:
        return {
          ...state,
          isLoading: false,
          heroDocumentPending: action.payload
        }
      case FETCH_DOCUMENT_PENDING_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
      case CREATE_DOCUMENT_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case CREATE_DOCUMENT_SUCCESS:
        return {
          ...state,
          isLoading: false
        }
      case CREATE_DOCUMENT_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
      case UPDATE_DOCUMENT_REQUEST:
        return {
          ...state,
          isLoading: true
        }
      case UPDATE_DOCUMENT_SUCCESS:
        return {
          ...state,
          isLoading: false
        }
      case UPDATE_DOCUMENT_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false
        }
        case DELETE_DOCUMENT_REQUEST:
          return {
            ...state,
            isLoading: true
          }
        case DELETE_DOCUMENT_SUCCESS:
          return {
            ...state,
            isLoading: false
          }
        case DELETE_DOCUMENT_FAILURE:
          return {
            ...state,
            error: action.error,
            isLoading: false
          }
          case UPDATE_DOCUMENT_BY_ADMIN_REQUEST:
            return {
              ...state,
              isLoading: true
            }
          case UPDATE_DOCUMENT_BY_ADMIN_SUCCESS:
            return {
              ...state,
              isLoading: false
            }
          case UPDATE_DOCUMENT_BY_ADMIN_FAILURE:
            return {
              ...state,
              error: action.error,
              isLoading: false
            }
    default:
      return state
  }
}

// Action Creators
export const fetchDocumentList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_DOCUMENT_REQUEST
      })
      const response = await API.get(EndPoints.DOCUMENTS + `/getAllDoc`)
      dispatch({
        type: FETCH_DOCUMENT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_DOCUMENT_FAILURE
      })
    }
  }
}
export const createDocument = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_DOCUMENT_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.DOCUMENTS + `/createAdminDocument`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_DOCUMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_DOCUMENT_FAILURE
      })
    }
  }
}

export const updateDocument = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_DOCUMENT_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.DOCUMENTS + `/updateAdminDocument`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_DOCUMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_DOCUMENT_FAILURE
      })
    }
  }
}
export const deleteDocument = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_DOCUMENT_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.DOCUMENTS + `/doc` + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_DOCUMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_DOCUMENT_FAILURE
      })
    }
  }
}

export const fetchDocumentByHeroId = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_DOCUMENT_BY_HEROID_REQUEST
      })
      const response = await API.get(EndPoints.DOCUMENTS + `/detail` + `/${id}`)
      dispatch({
        type: FETCH_DOCUMENT_BY_HEROID_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_DOCUMENT_BY_HEROID_FAILURE
      })
    }
  }
}

export const fetchDocumentPendingByHeroId = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_DOCUMENT_PENDING_REQUEST
      })
      const response = await API.get(EndPoints.DOCUMENTS + `/pending`)
      dispatch({
        type: FETCH_DOCUMENT_PENDING_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_DOCUMENT_PENDING_FAILURE
      })
    }
  }
}

export const updateDocumentByAdmin = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_DOCUMENT_BY_ADMIN_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.DOCUMENTS + `/updateHeroDocumentByAdmin`, data , {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_DOCUMENT_BY_ADMIN_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_DOCUMENT_BY_ADMIN_FAILURE
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/document.js